// extracted by mini-css-extract-plugin
export default {"carousel":"styles_carousel__MEZiW","dots":"styles_dots__0om+C","dot":"styles_dot__pupux","activeDot":"styles_activeDot__XVpVq"};